<div class="container">
    <h1>Salvar estado atual como predefinição para esta face</h1>
    <app-regular-input [(input)]="nome" [icon]="'/assets/icons/nome-predefinicao.svg'"></app-regular-input>
    <app-regular-button [title]="'Salvar'" (click)="save()" [disabled]="nome === ''"></app-regular-button>
    <app-regular-button [title]="'Fechar'" (click)="close()" [secondary]="true"></app-regular-button>
</div>

